module.exports = __webpack_public_path__ + "img/HowWeAssess_clipboard.733d6e77.svg";